import { useEffect, useMemo, useState } from "react";

const months = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

const speeds = [1, 2, 3];

export const useMapController = (data) => {
    const [mapMode, setMapMode] = useState("marker");
    const [radius, setRadius] = useState(50);

    const [currentFrame, setCurrentFrame] = useState(0);
    const [playing, setPlaying] = useState(false);
    const [speedIndex, setSpeedIndex] = useState(0);
    const speed = speeds[speedIndex];

    const [viewState, setViewState] = useState({
        center: { lat: -23, lng: -46 },
        zoom: 12
    });

    const grouped = useMemo(() => {
        const byMonth = {};

        data.forEach(item => {
            if (!item.system_dt_ini) return;

            const [datePart] = item.system_dt_ini.split(" ");
            const [day, month, year] = datePart.split("/");

            const key = `${month}/${year}`;

            if (!byMonth[key]) byMonth[key] = [];
            byMonth[key].push(item);
        });

        return byMonth;
    }, [data]);

    const frames = useMemo(() => {
        return Object.keys(grouped).sort((a, b) => {
            const [mA, yA] = a.split("/").map(Number);
            const [mB, yB] = b.split("/").map(Number);

            if (yA !== yB) return yB - yA;
            return mB - mA;
        });
    }, [grouped]);

    const formatFrameLabel = (frame) => {
        if (!frame) return "";

        const [month, year] = frame.split("/");
        return `${months[Number(month) - 1]}/${year}`;
    };

    useEffect(() => {
        if (!playing || frames.length === 0) return;
        const adjustedSpeed = Math.max(0.5, speed - 1);

        const interval = setInterval(() => {
            setCurrentFrame(prev => (prev + 1) % frames.length);
        }, 1000 / adjustedSpeed);

        return () => clearInterval(interval);
    }, [playing, speed, frames.length]);

    const nextFrame = () => {
        setCurrentFrame(prev => (prev + 1) % frames.length);
    };

    const prevFrame = () => {
        setCurrentFrame(prev => (prev - 1 + frames.length) % frames.length);
    };

    return {
        mapMode, setMapMode,
        radius, setRadius,
        currentFrame, setCurrentFrame,
        nextFrame, prevFrame,
        playing, setPlaying,
        speeds,
        speed,
        speedIndex,
        setSpeedIndex,
        grouped,
        frames,
        formatFrameLabel,
        viewState,
        setViewState
    };
};